<template>
  <div class="inquiry-cta-m">
    <div class="inquiry-cta-m__text">
      <p class="inquiry-cta-m__label en-font">{{ label }}</p>
      <p class="inquiry-cta-m__title">{{ title }}</p>
      <p class="inquiry-cta-m__desc">
        <span v-for="(line, i) in desc" :key="i"><br v-if="i" />{{ line }}</span>
      </p>
    </div>
    <a :href="href" target="_blank" rel="noopener noreferrer" class="inquiry-btn-m">
      <span>{{ buttonText }}</span>
      <span class="inquiry-btn-m__arrow" aria-hidden="true"></span>
    </a>
  </div>
</template>

<script>
export default {
  name: "MInquiryCta",
  props: {
    label: { type: String, default: "ONLINE INQUIRY" },
    title: { type: String, required: true },
    desc: { type: Array, default: () => [] },
    buttonText: { type: String, required: true },
    href: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/helpers/variables";

.inquiry-cta-m {
  width: 85vw;
  margin: 0 auto;
  .inquiry-cta-m__text {
    padding: 4px 0 4px 20px;
    border-left: 3px solid $color-blue;
    margin-bottom: 30px;
    .inquiry-cta-m__label {
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 2px;
      color: $color-blue;
      margin-bottom: 12px;
    }
    .inquiry-cta-m__title {
      font-size: 22px;
      font-weight: 700;
      line-height: 1.3;
      letter-spacing: -0.5px;
      color: $color-black;
      margin-bottom: 12px;
    }
    .inquiry-cta-m__desc {
      font-size: 14px;
      font-weight: 300;
      line-height: 1.7;
      color: #666;
    }
  }
  .inquiry-btn-m {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 52px;
    border: 1px solid $color-black;
    font-size: 15px;
    color: $color-black;
    letter-spacing: -0.3px;
    transition: background-color 0.2s, border-color 0.2s, color 0.2s;
    .inquiry-btn-m__arrow {
      width: 7px;
      height: 7px;
      margin-left: 10px;
      border-top: 1px solid currentColor;
      border-right: 1px solid currentColor;
      transform: rotate(45deg);
    }
    &:active {
      background-color: $color-blue;
      border-color: $color-blue;
      color: $color-white;
    }
  }
}
</style>
